<div class="body">
  <div class="top-bar">
    <div class="content-start"></div>
    <div class="logo-div">
      <img
        src="assets/images/ecolab-logo-white-app-header.png"
        alt="EcoLab Logo"
        class="logo"
      />
    </div>
    <div class="content-end">
      <select
        [value]="currentLanguage"
        (change)="languageChange($event)"
        class="select-dropdown"
      >
        <option
          *ngFor="let option of languageOptions"
          [value]="option?.value"
          [selected]="option.value === currentLanguage"
        >
          {{ option.value }}
        </option>
      </select>
    </div>
  </div>
  <main class="grow overflow-hidden">
    <div class="h-full relative show-bottom-fade">
      <div class="h-full min-h-0 overflow-scroll border-b border-white">
        <div class="max-w-xl mx-auto pt-2 px-4">
          <div class="esr-form w-full">
            <h2 class="h2">{{ translations['service_request_header'] }}</h2>
            <div
              *ngIf="!isFormValid"
              id="formError"
              class="text-sm text-red-600 mb-4"
            >
              {{ translations['error_submitting'] }}
            </div>
            <div class="mb-3">
              <label for="name"
                >{{ translations['on_site_contact_name'] }}
                <span class="sr-only">(required)</span>
              </label>
              <input
                id="name"
                type="text"
                name="name"
                maxlength="50"
                class="input"
                (input)="onNameChange()"
                required
              />
              <div
                *ngIf="!isNameValid"
                id="name-error"
                class="text-sm text-red-600 mb-4"
              >
                {{ translations['name_required'] }}
              </div>
            </div>
            <div class="mb-3">
              <label for="phone"
                >{{ translations['on_site_contact_phone'] }}
                <span class="sr-only">(required)</span>
              </label>
              <input
                id="phone"
                type="tel"
                inputmode="numeric"
                name="phone"
                placeholder="555-555-5555"
                (input)="onTelChange()"
                aria-describedby="phone-description"
                class="input"
                pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
              />
              <div
                *ngIf="!isPhoneValid"
                id="name-error"
                class="text-sm text-red-600 mb-4"
              >
                {{ translations['phone_required'] }}
              </div>
            </div>
            <div class="mb-3">
              <div class="relative flex gap-x-3">
                <div class="flex h-6 items-center">
                  <input
                    id="comments"
                    name="comments"
                    type="checkbox"
                    checked
                  />
                </div>
                <div class="text-sm leading-6">
                  <label
                    for="comments"
                    class="text-black text-base font-normal"
                    >{{ translations['receive_texts'] }}</label
                  >
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label for="description">{{
                translations['additional_details']
              }}</label>
              <textarea
                id="description"
                name="description"
                wrap="soft"
                rows="2"
                maxlength="500"
                aria-describedby="descriptionDirections"
                class="input-textarea"
                [value]="deviceData?.issueName[languageIndex]"
              ></textarea>
              <p id="descriptionDirections" class="text-xs">
                {{ translations['include_sensitive_info'] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </form> -->
  </main>
  <div class="layout-bottom">
    <div class="max-w-xl mx-auto px-4 py-4">
      <div class="flex mb-4">
        <!-- <input type="file" (change)="onFileSelected($event)" accept="image/*"> -->
        <div *ngIf="imageSrcs.length" class="d-flex w-full">
          <div
            class="mr-20"
            *ngFor="let src of imageSrcs; let i = index"
            (click)="removeimage(i)"
          >
            <img class="img-select" [src]="src" alt="Selected Image" />
            <span class="absolute rounded-full bg-black">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                class="w-4 h-4 fill-white"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <label
        for="file-upload"
        class="block outline-dotted outline-blue-600 outline-offset-4 outline-0 mb-2 focus-within:outline-2"
      >
        <span class="button-white-blue btn-outline mb-0"
          >{{ translations['upload_photo'] }}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            class="h-5 w-5 ml-2"
          >
            <path d="M12 9a3.75 3.75 0 100 7.5A3.75 3.75 0 0012 9z"></path>
            <path
              fill-rule="evenodd"
              d="M9.344 3.071a49.52 49.52 0 015.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 01-3 3h-15a3 3 0 01-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 001.11-.71l.822-1.315a2.942 2.942 0 012.332-1.39zM6.75 12.75a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zm12-1.5a.75.75 0 100-1.5.75.75 0 000 1.5z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </span>
        <input
          id="file-upload"
          accept="image*"
          (change)="onFilesSelected($event)"
          name="file-upload"
          type="file"
          class="sr-only"
          multiple
        />
      </label>
      <button
        type="submit"
        class="btn-blue-outline"
        [disabled]="!isFormValid"
        (click)="niceChat()"
      >
        {{ translations['submit'] }}
      </button>
      <button
        type="submit"
        class="btn-blue-outline"
        [disabled]="!isFormValid"
        (click)="navigate()"
      >
        {{ translations['summary'] }}
      </button>
    </div>
  </div>
</div>
